module.exports = __webpack_public_path__ + "static/eanest-logo-e503a4eba9bee0134001ba5f1c89880c.png";